document.addEventListener('DOMContentLoaded', () => {
  const predictiveSearch = document.querySelector('[data-predictive-search]');
  if (!predictiveSearch) return;

  const input = predictiveSearch.querySelector('[data-predictive-search-input]');
  const results = predictiveSearch.querySelector('[data-predictive-search-results]');
  if (!input || !results) return;

  let timer;
  let controller;

  const closeResults = () => {
    results.hidden = true;
    results.innerHTML = '';
    input.setAttribute('aria-expanded', 'false');
  };

  const openResults = () => {
    results.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  };

  const getSuggestions = async (term) => {
    if (controller) controller.abort();
    controller = new AbortController();

    const params = new URLSearchParams({
      q: term,
      'resources[type]': 'product',
      'resources[limit]': '8',
      'resources[options][fields]': 'title,product_type,variants.title,vendor,variants.sku',
      'resources[options][unavailable_products]': 'last',
      section_id: 'predictive-search'
    });

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}search/suggest?${params.toString()}`, {
        signal: controller.signal,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) throw new Error(`Predictive search failed: ${response.status}`);

      const html = await response.text();
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const section = documentFragment.querySelector('#shopify-section-predictive-search');
      if (!section || input.value.trim() !== term) return;

      results.innerHTML = section.innerHTML;
      openResults();
    } catch (error) {
      if (error.name !== 'AbortError') closeResults();
    }
  };

  input.addEventListener('input', () => {
    window.clearTimeout(timer);
    const term = input.value.trim();
    if (term.length < 2) {
      if (controller) controller.abort();
      closeResults();
      return;
    }
    timer = window.setTimeout(() => getSuggestions(term), 250);
  });

  input.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeResults();
  });

  document.addEventListener('click', (event) => {
    if (!predictiveSearch.contains(event.target)) closeResults();
  });
});
